/**
 * ============================================================================
 * REQUEST TRACKING UTILITIES
 * Prevent race conditions in concurrent requests
 * ============================================================================
 */

const requestTrackers = {}

/**
 * Track request to prevent race conditions
 * @param {string} actionType - Action type identifier
 * @returns {number} Current request ID
 */
export function trackRequest (actionType) {
	if (!requestTrackers[actionType]) {
		requestTrackers[actionType] = 0
	}
	requestTrackers[actionType] += 1
	return requestTrackers[actionType]
}

/**
 * Check if request is still current
 * @param {string} actionType - Action type identifier
 * @param {number} requestId - Request ID to check
 * @returns {boolean} True if request is current
 */
export function isCurrentRequest (actionType, requestId) {
	return requestId === requestTrackers[actionType]
}

/**
 * Reset request tracker for specific action
 * @param {string} actionType - Action type identifier
 */
export function resetRequestTracker (actionType) {
	delete requestTrackers[actionType]
}

/**
 * Clear all request trackers
 */
export function clearAllTrackers () {
	Object.keys(requestTrackers).forEach(key => {
		delete requestTrackers[key]
	})
}
